// Qué código de descuento se muestra en una línea: uno que descuenta $0 no se etiqueta.

/** Código a mostrar; `undefined` si no hay o si su descuento es 0 (p. ej. pendiente de revalidar). */
export function shownDiscountCode(line: {
    discountCode?: string | null;
    discountCents?: number | null;
}): string | undefined {
    if (!line.discountCode || line.discountCents === 0) return undefined;
    return line.discountCode;
}
